import type { NeighborElevationCollection } from "../../../../rx/memo/useNodeNeighborBaseFloorElevationReactiveMap"
import { VERTICES_PER_TILE } from "../../consts"
import getTerrainMesh1FromNormalizedTileRXZ from "./getTerrainMesh1FromNormalizedTileRXZ"

/**
 * Half the size of a tile in vertices, used for normalizing coordinates to [-1, 1] range.
 * This constant is critical for coordinate space conversion between tile-local and normalized coordinates.
 */
const halfSize = VERTICES_PER_TILE / 2

/**
 * @param baseElevationsCollection - Collection containing base elevation and 8 neighbor elevations
 *   with pre-computed averages for smooth interpolation. This comes from the reactive
 *   elevation system that tracks terrain changes.
 * @param rx - X-coordinate in tile-local space (typically -halfSize to +halfSize)
 * @param ry - Y-coordinate in tile-local space (typically -halfSize to +halfSize)
 */
export default function getTerrainMesh1Z(
  baseElevationsCollection: NeighborElevationCollection,
  rx: number,
  ry: number
): number {
  // Normalize coordinates to [-1, 1] range for weight calculation
  const nx = rx / halfSize
  const ny = ry / halfSize

  return getTerrainMesh1FromNormalizedTileRXZ(baseElevationsCollection, nx, ny)
}